import {
    ECOSISTEMA_LOADING,
    ECOSISTEMA_LOADED,
    ECOSISTEMA_ERROR,
  } from './../../types/ecosistema';

const INITIAL_STATE = {
    ecosistema:[],
    ecosistemaLoading:false,
    ecosistemaLoaded:false,
    ecosistemError:''
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case ECOSISTEMA_LOADING:
            return {
                ... state,
                ecosistema:[],
                ecosistemaLoading:true,
                ecosistemaLoaded:false,
                ecosistemError: ''
            }
        case ECOSISTEMA_LOADED:
            return {
                ...state,
                ecosistema:action.payload,
                ecosistemaLoading:false,
                ecosistemaLoaded:true,
                ecosistemError: '',
            };
        case ECOSISTEMA_ERROR:
            return {
                ...state,
                ecosistema:[],
                ecosistemaLoading:false,
                ecosistemaLoaded:false,
                ecosistemError: action.payload,
            }
        default: return state;
    }
}